import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string';
import { i18next } from '@hotjar/translations';
import { changeProfilePassword } from '../../domains/profile/api';
import type { ChangeProfilePasswordResponse } from '../../domains/profile/types';

export const mutateProfilePassword = async ({
  userId,
  currentPassword,
  newPassword,
  newPasswordConfirm,
}: {
  userId: number;
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}): Promise<ChangeProfilePasswordResponse> => {
  const response = await changeProfilePassword(userId, {
    currentPassword,
    newPassword,
    newPasswordConfirm,
    locale: i18next.resolvedLanguage ?? undefined,
  });
  return keysToCamelCase(response.data, true);
};
